<template>
<div class="chapter">
<div class="inner_page">
<p class="img3"><img alt="Image" src="images/dot.jpg" style="max-width:100%;"/></p>
<p class="fmh2">CONTENTS</p>
<p class="toc"><a class="htt" href="#/xhtml/introduction">Introduction</a></p>
<p class="toc1"><a class="htt" href="#/xhtml/Chapter01">CHAPTER 1: MORNiNG WAKE-UP TO EVENING INDULGENCE</a></p>
<p class="toc2"><a class="htt" href="#/xhtml/Chapter02">CHAPTER 2: MANAGING DiSEASE</a></p>
<p class="toc2"><span class="htt" href="#/xhtml/Chapter03" title="Link target outside of Sample">CHAPTER 3: MANAGING WELL-BEiNG</span></p>
<p class="toc2"><span class="htt" href="#/xhtml/Chapter04" title="Link target outside of Sample">CHAPTER 4: MANAGING BEAuTY</span></p>
<p class="toc3"><span class="htt" href="#/xhtml/Chapter04_1" title="Link target outside of Sample">Overhaul Your Look</span></p>
<p class="toc4"><span class="htt" href="#/xhtml/Chapter04_2" title="Link target outside of Sample">Overhaul Your Cosmetics</span></p>
<p class="toc5"><span class="htt" href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4668be7d